/**
 * The app's fixed top bars (TopNavigationBar's `app` system bar, plus a Vuetify app bar if a layout
 * has one) stay visible: the AVA side panel and every app-level slide-out start below them.
 * The height comes from Vuetify's own layout registry ($vuetify.application), so no size is
 * hard-coded and a layout without top bars gets 0.
 * App.vue publishes it on <html> as APP_TOP_VAR for the slide-out rule in App.vue's styles;
 * AvaAssistant reads appTopHeight directly for its geometry.
 * No Vue or path-alias imports, so `npm run test:unit` (node --test) can load it directly.
 */

/** CSS variable holding the top bars' height, e.g. `48px`. */
export const APP_TOP_VAR = '--ava-app-top';

/**
 * @param {{ bar?: number, top?: number } | undefined} application `this.$vuetify.application`
 * @returns {number} height in px of the fixed bars at the top of the app
 */
export function appTopHeight(application) {
  return (application?.bar || 0) + (application?.top || 0);
}

/** appTopHeight as a CSS length for APP_TOP_VAR. */
export function appTopCss(application) {
  return `${appTopHeight(application)}px`;
}
